import { Auth0ClientOptions } from '@auth0/auth0-spa-js';

export type EnvironmentVariables = {
  auth0?: Auth0ClientOptions;
  baseUrl?: string;
  apiPrefix?: string;
  api2BaseUrl?: string;
  appsBaseUrl?: string;
  gmsBaseUrl?: string;
  /** Base URL for point-o-gms app (navbar links forward here when set) */
  pointOGmsBaseUrl?: string;
  eventsBaseUrl?: string;
  p2pBaseUrl?: string;
  gmsApiBaseUrl?: string;
  eventsPublicBaseUrl?: string;
  p2pPublicBaseUrl?: string;
  reconciliationUiBaseUrl?: string;
  localScaffoldingUrl?: string;
  buildScaffoldingUrl?: string;
  s3Url?: string;
  sentry?: {
    dsn?: string;
    environment?: string;
    tracesSampleRate?: number;
  };
  joditProLicense?: string;
  scaffoldingApiBase?: string;
};

declare global {
  interface Window {
    envVars: EnvironmentVariables;
    pendo: any;
  }
}

export const resolvedEnvironment: EnvironmentVariables = window.envVars;
